import { gql } from '@apollo/client';

export const GET_AREAS_BY_WAREHOUSE_ID = gql`
    query GetAreasByWarehouseId($warehouseId: Long!) {
        areaList: getAreasByWarehouseId(warehouseId: $warehouseId) {
            id
            name
            sortingCode
            warehouseId
            dspId
            zipcodeList
        }
    }
`;

export interface AreaType {
    id: string;
    name: string;
    sortingCode?: string;
    warehouseId: string;
    dspId: string;
    zipcodeList: string[];
}

export interface GetAreasByWarehouseIdResponse {
    areaList: AreaType[];
} 